/**
 * Web {@link ExternalUrlPort} (ELARA-1178): a same-tab navigation. Used for downloads such as the
 * Elara vCard, which the server sends as an attachment, so the app stays on the current page.
 */
import type { ExternalUrlPort } from '@elara/client-core/lib/external-url-port';

export function createWebExternalUrlPort(): ExternalUrlPort {
  return {
    async open(url) {
      window.location.assign(url);
    },
  };
}
